import { Component } from 'react';

import intersection from 'lodash/intersection';
import MembershipStore from 'modules/membership/MembershipStore';
import PropTypes from 'prop-types';

export const CONDITION = {
  ALL: 'ALL',
  NONE: 'NONE',
  SOME: 'SOME'
};

const CONDITION_HANDLERS = {
  [CONDITION.ALL]: (membershipConfigs, configs) =>
    intersection(membershipConfigs, configs).length === configs.length,
  [CONDITION.NONE]: (membershipConfigs, configs) =>
    intersection(membershipConfigs, configs).length === 0,
  [CONDITION.SOME]: (membershipConfigs, configs) =>
    intersection(membershipConfigs, configs).length > 0
};

/**
 * This HOC defines how a children element should be displayed given some membership config.
 */
export class MembershipConfigWatcher extends Component {
  static propTypes = {
    children: PropTypes.node,
    conditions: PropTypes.array
  };

  verifyCondition(configs, condition) {
    const membershipConfigs = MembershipStore?.configs || [];
    const handler =
      CONDITION_HANDLERS[condition] || CONDITION_HANDLERS[CONDITION.SOME];

    return handler(membershipConfigs, configs);
  }

  render() {
    const { children, conditions } = this.props;
    let meetsCondition = false;

    for (let i = 0; i < conditions.length && !meetsCondition; i++) {
      const { configs, condition } = conditions[i];

      meetsCondition = this.verifyCondition(configs, condition);
    }

    if (meetsCondition) {
      return children;
    }

    return null;
  }
}

export default MembershipConfigWatcher;
